import styled from 'styled-components';

import * as URLS from '@wecasa/common/src/constants/urls';
import colors from '@wecasa/common/src/utils/colors';
import { toRem } from '@wecasa/common/src/utils/styles';

import { translate } from '@wecasa/i18n';

import Icon from '@wecasa/web-ui/src/components/icon/icon';
import SimpleLink from '@wecasa/web-ui/src/components/link/simple-link';

const t = translate('basket');

const AllowanceLine = styled.div`
  margin-top: ${toRem(10)};
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const AllowanceLink = styled.span`
  margin-right: ${toRem(5)};
`;

const AllowanceInfo = () => (
  <AllowanceLine>
    <AllowanceLink>
      <SimpleLink title={t('.childcare.allowance.link_title')} openInNewTab href={URLS.ALLOWANCE_CAF}>
        {t('.childcare.allowance.info')}
      </SimpleLink>
    </AllowanceLink>
    <span>
      <Icon name='information' size={25} color={colors.ink100} />
    </span>
  </AllowanceLine>
);

export default AllowanceInfo;
